<template>
    <form class="content-form-request bg-white" @submit.prevent="sendForm()">
        <div class="content-form-request-element">
            <div class="content-form-request-header">
                <h2>Os seus dados</h2>
            </div>
            <div class="content-form-request-body">
                <div class="content-element">
                    <div class="row">
                        <div class="col-lg-12">
                            <div class="content-element-input">
                                <input
                                    type="text"
                                    name="commercial name"
                                    v-model="form.commercial_name"
                                    placeholder="Nome Comercial"
                                    required
                                />
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-lg-12">
                            <div class="content-element-input">
                                <input
                                    type="text"
                                    name="address"
                                    v-model="form.morada"
                                    placeholder="Morada"
                                    required
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div class="content-element">
                    <div class="row">
                        <div class="col-lg-4">
                            <div class="content-element-input">
                                <input
                                    type="text"
                                    name="port"
                                    placeholder="Porta"
                                    v-model="form.porta"
                                    required
                                />
                            </div>
                        </div>
                        <div class="col-lg-4">
                            <div class="content-element-input">
                                <input
                                    type="text"
                                    name="floor"
                                    placeholder="Andar"
                                    v-model="form.andar"
                                />
                            </div>
                        </div>
                        <div class="col-lg-4">
                            <div class="content-element-input">
                                <input
                                    type="text"
                                    name="side"
                                    placeholder="Lado"
                                    v-model="form.lado"
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div class="content-element">
                    <div class="row">
                        <div class="col-md-6">
                            <div class="content-element-input">
                                <input
                                    type="text"
                                    name="postal_code"
                                    placeholder="Código Postal"
                                    v-model="form.codigo_postal"
                                    required
                                />
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="content-element-input">
                                <input
                                    type="text"
                                    name="city"
                                    placeholder="Localidade"
                                    v-model="form.localidade"
                                    required
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div class="content-element">
                    <div class="row">
                        <div class="col-md-12">
                            <div class="content-element-input">
                                <input
                                    type="text"
                                    name="name_contact_person"
                                    placeholder="Nome da pessoa de contacto"
                                    v-model="form.name"
                                    required
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div class="content-element">
                    <div class="row">
                        <div class="col-md-12">
                            <div class="content-element-input">
                                <input
                                    type="email"
                                    name="email"
                                    placeholder="Endereço de email"
                                    v-model="form.email"
                                    required
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div class="content-element">
                    <div class="row">
                        <div class="col-lg-6">
                            <div class="content-element-input">
                                <input
                                    type="phone"
                                    name="phone"
                                    placeholder="Nº de telefone"
                                    v-model="form.phone"
                                    required
                                />
                            </div>
                        </div>
                        <div class="col-lg-6">
                            <div class="content-element-input">
                                <input
                                    type="text"
                                    name="website"
                                    placeholder="website"
                                    v-model="form.site"
                                    required
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div class="content-element">
                    <div class="row">
                        <div class="col-lg-6">
                            <div class="content-element-select">
                                <select v-model="categorySelected" required>
                                    <option name="categorias" value="" disabled>
                                        Categoria
                                    </option>
                                    <option
                                        :name="category"
                                        :value="category"
                                        v-for="(category, index) in categories"
                                        :key="index"
                                    >
                                        {{ category }}
                                    </option>
                                </select>
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="20"
                                    height="15"
                                    viewBox="0 0 20 15"
                                >
                                    <path
                                        d="M795,746l-10-15h20Z"
                                        transform="translate(-785 -731)"
                                        fill="#338545"
                                        fill-rule="evenodd"
                                    />
                                </svg>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="content-form-request-terms">
            <div class="content-input-check">
                <input type="checkbox" name="terms" required />
                <label
                    >Aceitação dos
                    <router-link
                        tag="a"
                        :to="{
                            name: 'Politica',
                            params: {
                                slug: 'termos-e-condicoes-de-vendautilizacao',
                            },
                        }"
                    >
                        termos e condições de venda</router-link
                    ></label
                >
            </div>
        </div>
        <div class="content-form-request-recaptcha">
            <p>Please tick the box to continue:</p>
            <vue-recaptcha ref="recaptcha" sitekey="6Lfx2_sfAAAAAC61iJG8I9xo9x79an_SL8-iNUyI" />
        </div>
        <div class="content-form-request-btns">
            <button class="btn-send">Submeter</button>
        </div>
        <!-- <div class="content-form-request-info">
            <p>
                <span>*</span> Fee mensal de gestão de conta: 38.99€ (sem iva)
            </p>
        </div> -->
    </form>
</template>
<script>
import axios from "axios";
import { VueRecaptcha } from "vue-recaptcha";

export default {
    data() {
        return {
            form: {
                name: "",
                nickname: "",
                phone: "",
                email: "",
                mensagem: "",
                nome_comercial: "",
                morada: "",
                porta: "",
                andar: "",
                lado: "",
                codigo_postal: "",
                localidade: "",
                site: "",
                custom: [],
                origin: "parceiros-info",
                access_token: this.$store.getters["User/userIsLogged"],
            },
            categorySelected: "",
        };
    },
	props: ['categories'],
    components: {
        VueRecaptcha,
    },
    methods: {
        // onEvent() {
        //     // when you need a reCAPTCHA challenge
        //     this.$refs.recaptcha.execute();
        // },
        // submit() {
        //     if (this.form.robot) {
        //         console.log(this.form);
        //     }
        // },
        // onVerify: function (response) {
        //     if (response) this.form.robot = true;
        // },
        sendForm() {
			this.form.custom.push(this.categorySelected);
            axios
                .post("/api/v1/setlead", this.form)
                .then((response) => {
                    if (!response.data.response.success) {
                        this.$store.dispatch("setAlert", {
                            type: "error",
                            title: "Erro",
                            message: response.data.response.message.text,
                        });
                        return;
                    }
                    this.$store.dispatch("setAlert", {
                        type: "success",
                        title: "Sucesso",
                        message: response.data.response.message.text,
                    });
                    this.clearForm();
                })
                .catch((error) => {
                    this.$store.dispatch("setAlert", {
                        type: "error",
                        title: "Erro",
                        message: error.response.data.message,
                    });
                });
        },
        clearForm() {
            for (let i in this.form) {
                if (i === "custom") {
                    this.form[i] = [];
                } else if (i !== "origin") {
                    this.form[i] = "";
                }
            }
            this.categorySelected = "";
        },
        // getCategories() {
        //     axios
        //         .get("/api/v1/lead/getcategories")
        //         .then((response) => {
        //             this.categories = response.data.response.data;
        //         })
        //         .catch((error) => {
        //             console.error(error);
        //             this.$store.dispatch("setAlert", {
        //                 type: "error",
        //                 title: "Erro",
        //                 message: error.response.data.message,
        //             });
        //         });
        // },
    },
    mounted() {
        // this.getCategories();
    },
};
</script>
<style lang="scss">
.content-form-request {
    padding: 30px 0px;
    @media (max-width: 991px) {
        padding: 30px 20px;
    }
    &-header {
        text-align: left;
        margin-bottom: 40px;
        @media (max-width: 991px) {
            margin-bottom: 30px;
        }
        h2 {
            font-size: 28px;
            font-family: "Font Bold";
            color: var(--green-medium);
            margin-bottom: 0px;
            @media (max-width: 991px) {
                font-size: 18px;
            }
        }
    }
    &-body {
        .content-element {
            margin-bottom: 0;
            &-radio {
                display: flex;
                align-items: center;
                margin-bottom: 40px;
                @media (max-width: 991px) {
                    flex-wrap: wrap;
                    margin-bottom: 30px;
                }
                &-input {
                    &:not(:last-child) {
                        margin-right: 47px;
                        @media (max-width: 991px) {
                            margin-right: 20px;
                        }
                    }
                    @media (max-width: 991px) {
                        margin-bottom: 10px;
                    }
                    [type="radio"]:checked,
                    [type="radio"]:not(:checked) {
                        position: absolute;
                        left: 3px;
                        opacity: 0;
                    }
                    [type="radio"]:checked + label,
                    [type="radio"]:not(:checked) + label {
                        position: relative;
                        padding-left: 40px;
                        height: 30px;
                        cursor: pointer;
                        display: flex;
                        align-items: center;
                        font-size: 20px;
                        font-family: "Font Regular";
                        color: var(--green-dark);
                        margin-bottom: 0px;
                        line-height: 1;
                        @media (max-width: 991px) {
                            padding-left: 30px;
                            height: 20px;
                            font-size: 16px;
                        }
                    }
                    [type="radio"]:checked + label:before,
                    [type="radio"]:not(:checked) + label:before {
                        content: "";
                        position: absolute;
                        left: 0;
                        top: 0;
                        width: 30px;
                        height: 30px;
                        border-radius: 100%;
                        background: #fff;
                        border: 1px solid #bebebe;
                        @media (max-width: 991px) {
                            width: 20px;
                            height: 20px;
                        }
                    }
                    [type="radio"]:checked + label:after,
                    [type="radio"]:not(:checked) + label:after {
                        content: "";
                        width: 14px;
                        height: 14px;
                        background: var(--green-medium);
                        position: absolute;
                        top: 8px;
                        left: 8px;
                        border-radius: 100%;
                        -webkit-transition: all 0.2s ease;
                        transition: all 0.2s ease;
                        @media (max-width: 991px) {
                            width: 12px;
                            height: 12px;
                            top: 4px;
                            left: 4px;
                        }
                    }
                    [type="radio"]:not(:checked) + label:after {
                        opacity: 0;
                        -webkit-transform: scale(0);
                        transform: scale(0);
                    }
                    [type="radio"]:checked + label:after {
                        opacity: 1;
                        -webkit-transform: scale(1);
                        transform: scale(1);
                    }
                }
            }
            &-input-date {
                position: relative;
                width: 100%;
                margin-bottom: 40px;
                @media (max-width: 991px) {
                    margin-bottom: 30px;
                }
                input {
                    width: 100%;
                    height: 50px;
                    background: var(--white);
                    border: 1px solid #bebebe;
                    border-radius: 10px;
                    padding-left: 20px;
                    font-size: 20px;
                    font-family: "Font Regular";
                    color: var(--green-dark);
                    outline: none;
                    @media (max-width: 991px) {
                        height: 40px;
                        font-size: 16px;
                        border-radius: 5px;
                        padding-left: 15px;
                    }
                    &::-webkit-input-placeholder {
                        /* Chrome/Opera/Safari */
                        color: #b7b8b8;
                    }
                    &::-moz-placeholder {
                        /* Firefox 19+ */
                        color: #b7b8b8;
                    }
                    &:-ms-input-placeholder {
                        /* IE 10+ */
                        color: #b7b8b8;
                    }
                    &:-moz-placeholder {
                        /* Firefox 18- */
                        color: #b7b8b8;
                    }
                    &::-webkit-inner-spin-button,
                    &::-webkit-calendar-picker-indicator {
                        display: none;
                        -webkit-appearance: none;
                        opacity: 0;
                    }
                }
                svg {
                    position: absolute;
                    right: 7px;
                    top: 50%;
                    transform: translateY(-50%);
                    background: #fff;
                    max-width: 20px;
                    pointer-events: none;
                    @media (max-width: 991px) {
                        right: 5px;
                    }
                }
            }
            &-input {
                width: 100%;
                margin-bottom: 40px;
                @media (max-width: 991px) {
                    margin-bottom: 20px;
                }
                input {
                    width: 100%;
                    height: 70px;
                    background: var(--white);
                    border: 1px solid #bebebe;
                    border-radius: 10px;
                    padding-left: 20px;
                    font-size: 25px;
                    font-family: "Font Regular";
                    color: var(--green-dark);
                    outline: none;
                    @media (max-width: 991px) {
                        font-size: 18px;
                    }
                    &::-webkit-input-placeholder {
                        /* Chrome/Opera/Safari */
                        color: #b7b8b8;
                    }
                    &::-moz-placeholder {
                        /* Firefox 19+ */
                        color: #b7b8b8;
                    }
                    &:-ms-input-placeholder {
                        /* IE 10+ */
                        color: #b7b8b8;
                    }
                    &:-moz-placeholder {
                        /* Firefox 18- */
                        color: #b7b8b8;
                    }
                }
                textarea {
                    width: 100%;
                    min-height: 210px;
                    display: block;
                    background: var(--white);
                    border: 1px solid #bebebe;
                    border-radius: 10px;
                    padding-top: 20px;
                    padding-left: 20px;
                    font-size: 25px;
                    font-family: "Font Regular";
                    color: var(--green-dark);
                    outline: none;
                    resize: none;
                    @media (max-width: 991px) {
                        min-height: 150px;
                        font-size: 18px;
                    }
                    &::-webkit-input-placeholder {
                        /* Chrome/Opera/Safari */
                        color: #b7b8b8;
                    }
                    &::-moz-placeholder {
                        /* Firefox 19+ */
                        color: #b7b8b8;
                    }
                    &:-ms-input-placeholder {
                        /* IE 10+ */
                        color: #b7b8b8;
                    }
                    &:-moz-placeholder {
                        /* Firefox 18- */
                        color: #b7b8b8;
                    }
                }
            }
            &-select {
                position: relative;
                width: 100%;
                margin-bottom: 40px;
                @media (max-width: 991px) {
                    margin-bottom: 30px;
                }
                select {
                    width: 100%;
                    height: 70px;
                    background: var(--white) !important;
                    border: 1px solid #bebebe;
                    border-radius: 10px;
                    padding-left: 20px;
                    font-size: 25px;
                    font-family: "Font Regular";
                    color: var(--green-dark);
                    outline: none;
                    appearance: none;
                    -moz-appearance: none;
                    -webkit-appearance: none;
                    @media (max-width: 991px) {
                        font-size: 18px;
                    }
                }
                svg {
                    position: absolute;
                    right: 20px;
                    top: 50%;
                    transform: translateY(-50%);
                    max-width: 15px;
                    pointer-events: none;
                }
            }
            &-text {
                text-align: left;
                margin-bottom: 10px;
                @media (max-width: 991px) {
                    margin-bottom: 20px;
                }
                p {
                    font-size: 20px;
                    font-family: "Font Regular";
                    color: #555555;
                    margin-bottom: 0;
                    @media (max-width: 991px) {
                        font-size: 16px;
                    }
                }
            }
        }
    }
    &-details {
        display: flex;
        align-items: center;
        padding: 20px 30px;
        background: var(--green-medium);
        border-radius: 10px;
        margin-bottom: 45px;
        @media (max-width: 991px) {
            flex-direction: column;
            align-items: flex-start;
            padding: 20px;
            border-radius: 5px;
            margin-bottom: 30px;
        }
        &-text {
            text-align: left;
            &:first-child {
                margin-right: 100px;
                @media (max-width: 991px) {
                    margin-right: 0;
                    margin-bottom: 10px;
                }
            }
            .title {
                font-size: 18px;
                font-family: "Font Regular";
                color: var(--white);
                margin-bottom: 0;
                @media (max-width: 991px) {
                    font-size: 16px;
                }
            }
            .text {
                font-size: 30px;
                font-family: "Font Bold";
                color: var(--white);
                margin-bottom: 0;
                @media (max-width: 991px) {
                    font-size: 20px;
                }
            }
        }
    }
    &-recaptcha {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        margin: 2rem 0;
        p {
            font-size: 16px;
            font-family: "Font Regular", sans-serif;
            color: var(--green-dark);
            margin-bottom: 0;
            padding: 0.5rem 0;
            @media (max-width: 991px) {
                font-size: 16px;
            }
            @media screen and (max-width: 768px) {
                font-size: 14px;
            }
            @media screen and (max-width: 576px) {
                font-size: 12px;
            }
        }
    }
    &-btns {
        width: 100%;
        display: flex;
        justify-content: flex-start;
        .btn-send {
            width: 250px;
            height: 72px;
            background: var(--green-medium);
            border: 1px solid var(--green-medium);
            border-radius: 10px;
            box-shadow: 5px 5px 10px rgba(0, 0, 0, 0.16);
            display: flex;
            font-size: 25px;
            font-family: "Font Regular";
            color: var(--white);
            transition: 500ms;
            margin: 30px 0px;
            @media screen and (max-width: 768px) {
                width: 200px;
                height: 60px;
                margin: 15px 0px;
            }
            &:hover,
            &:focus {
                cursor: pointer;
                background: var(--white);
                color: var(--green-medium);
            }
        }
    }
    &-info {
        padding: 2rem 0;
        p {
            font-family: "Font Regular", sans-serif;
            font-size: 22px;
            color: #112d23;
            text-align: left;
            @media screen and (max-width: 991px) {
                font-size: 18px;
            }
        }
    }
}
</style>
